import { combineReducers } from 'redux';

import data from './data';
import events from './events';
import messageIds from './messageIds';
import ui from './ui';

/**
 * @typedef {{
 *   ui: import("./ui").UIState,
 *   data: import("./data").InterventionDataEntity,
 *   events: import("./events").InterventionEventSlice,
 *   messageIds: import("./messageIds").InterventionMessageIdsReducer,
 * }} InterventionUIReducer
 */

export default combineReducers({
  ui,
  data,
  events,
  messageIds,
});
